export * from "D:/workspace/all_web/src/cmm/app/app_rem.js";
export * from "D:/workspace/all_web/src/_cmm/js/httpbase.js";
export * from "D:/workspace/all_web/src/_cmm/js/conf.js";
export * from "D:/workspace/all_web/src/_cmm/js/obj.js";
export * from "D:/workspace/all_web/src/_cmm/js/util.js";
export * from "D:/workspace/all_web/src/_cmm/js/wxaudio.js";





export function gotoLink(url) {
    // window.history.replaceState(null, null, window.location.href);
    // window.location.href = url;
    window.location.replace(url);
}

const h5orcdn = 'h5';
export const VR_linggangtea = `https://${h5orcdn}.yeapar.com/yangxivr/cy01`;
export const VR_xiaobantang = `https://${h5orcdn}.yeapar.com/yangxivr/cy02`;
// export const VR_cyzmd = `https://${h5orcdn}.yeapar.com/yangxivr/cyzmd`;





// 不要再用
export const ver = 1;
export const qver = "?"+ver;


